module.exports = __webpack_public_path__ + "static/hero-729c92bca95e63132cfcbf1e9198e339.jpg";